import type { User } from '@appTypes/auth.types';

export function hasPermission(user: User | null, permission: string): boolean {
  if (!user) return false;
  return user.permissions.includes(permission) || user.roles.includes('admin');
}

export function hasAnyPermission(user: User | null, permissions: string[]): boolean {
  if (!user) return false;
  if (user.roles.includes('admin')) return true;
  return permissions.some((p) => user.permissions.includes(p));
}

export function hasAllPermissions(user: User | null, permissions: string[]): boolean {
  if (!user) return false;
  if (user.roles.includes('admin')) return true;
  return permissions.every((p) => user.permissions.includes(p));
}

/**
 * Developer tools access — an explicit per-user grant.
 *
 * Deliberately does NOT fall back to `roles.includes('admin')` like the
 * permission helpers above: admins must not get developer tools implicitly.
 * Mirrors the backend's `require_developer` dependency.
 */
export function hasDeveloperAccess(user: User | null): boolean {
  if (!user) return false;
  return user.developerAccess === true;
}
